import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  withStyles
} from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose, lifecycle } from 'recompose';
import CancelButton from '../atoms/CancelButton';

const styles = {
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20
  },
  tableCellItem: {
    borderBottom: '2px solid #E0E0E0',
    borderTop: '2px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    fontWeight: 700,
    width: '30%'
  },
  tableCellData: {
    borderBottom: '2px solid #E0E0E0',
    borderTop: '2px solid #E0E0E0'
  },
  button: {
    margin: '5px auto'
  },
  detailTable: {
    marginBottom: 10
  }
};

const enhance = compose(
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    setOpenConfirmModal,
    menuSetting,
    menuSettingConfirm,
    updateSettingMenuFree
  }) => {
    return (
      <>
        <div className={classes.contentContainer}>
          <Typography className={classes.title} variant="h6">
            無料メニュー設定
          </Typography>

          <div>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニューID
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {menuSetting.menuId}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {menuSetting.menuName}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    税込価格
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {menuSetting.includedTaxPrice}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    無料提供
                    <br />
                    開始日〜終了日
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    <span>{menuSettingConfirm.gochiKidFreeStartDate}</span>
                    <span>〜</span>
                    <span>{menuSettingConfirm.gochiKidFreeEndDate}</span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    食数（無料提供総数）
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {menuSettingConfirm.gochiKidFreeSet}
                  </TableCell>
                </TableRow>
                {menuSettingConfirm.gochiKidFreeFilterFlag === 1 && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        一般食数
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {menuSettingConfirm.gochiKidFreeNormalSet}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        応援キッズ食数
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {menuSettingConfirm.gochiKidFreePoorSet}
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>

            <div>
              <CancelButton
                onClickAction={() => {
                  setOpenConfirmModal(false);
                }}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={updateSettingMenuFree}
                className={classes.button}
              >
                確定
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
